import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { KeycloakAuthService } from '../app/shared/services/keycloack.service';
import { firstValueFrom } from 'rxjs';
import { REQUIRED_ROLES } from '../app/shared/constants/auth-roles.constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  keycloakAuthService = inject(KeycloakAuthService);

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
      return false;
    }

    const requiredRoles = REQUIRED_ROLES;

    if (requiredRoles.length === 0) {
      return true;
    }

    return firstValueFrom(
      this.keycloakAuthService.userRoles$.pipe(
        map((userRoles) => {
          const hasAccess = requiredRoles.some((role) =>
            userRoles.includes(role)
          );

          if (!hasAccess) {
            this.router.navigate(['/forbidden']);
          }

          return hasAccess;
        })
      )
    );
  }
}
